(() => {
  customElements.whenDefined('x-drawer').then(() => {
    const XDrawer = customElements.get('x-drawer');
    if (!XDrawer) return;

    class QuickBuyDrawer extends XDrawer {
      constructor() {
        super();
        this.addEventListener('dialog:after-hide', () => {
          this.innerHTML = '';
        });
      }

      async show() {
        const controls = this.controls || [];
        const showLoadingBar = controls.every((c) => c.querySelector('button-content') === null);

        [this, ...controls].forEach((c) => c.setAttribute('aria-busy', 'true'));

        const promise = (async () => {
          if (showLoadingBar) {
            document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));
          }
          try {
            const url = this.getAttribute('product-url');
            const response = await fetch(url, { headers: { Accept: 'text/html' } });
            const html = await response.text();
            const tempDoc = new DOMParser().parseFromString(html, 'text/html');
            const template = tempDoc.getElementById('quick-buy-content');
            if (template && template.content.firstElementChild) {
              this.replaceChildren(template.content.cloneNode(true).firstElementChild);
            }
          } finally {
            [this, ...controls].forEach((c) => c.setAttribute('aria-busy', 'false'));
            if (showLoadingBar) {
              document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
            }
          }
        })();

        return super.show({ conditionToFulfill: promise });
      }
    }

    if (!customElements.get('quick-buy-drawer')) {
      customElements.define('quick-buy-drawer', QuickBuyDrawer);
    }
  });

  // Keep the quick-buy-drawer's product-url in sync when a card swatch changes
  document.addEventListener('change', (e) => {
    const target = e.target;
    if (!(target instanceof HTMLInputElement)) return;
    if (target.type !== 'radio') return;
    if (!target.closest('.product-card__swatch-list')) return;
    if (!target.hasAttribute('data-product-url')) return;

    const card = target.closest('product-card, .product-card');
    const drawer = card && card.querySelector('quick-buy-drawer');
    if (drawer) {
      drawer.setAttribute('product-url', target.getAttribute('data-product-url'));
    }
  });
})();
